import { findAll } from './dom.js';

const CARD_DECK_SELECTOR = '[data-bp-deck~="card"]';
const CARD_SELECTOR = '.ab-mcard';
const TITLE_SELECTOR = '.ab-mcard-title';

// A "card" deck opens the focused card on keyboard focus, so a card without its own link takes focus and a name.
export function initializeCardDecks(root) {
  let count = 0;
  for (const deck of findAll(root, CARD_DECK_SELECTOR)) {
    for (const card of deck.querySelectorAll(CARD_SELECTOR)) {
      if (card.hasAttribute('tabindex') || card.querySelector('a[href]')) continue;
      card.setAttribute('tabindex', '0');
      card.setAttribute('role', 'group');
      const title = card.querySelector(TITLE_SELECTOR)?.textContent.replace(/\s+/gu, ' ').trim();
      if (title && !card.hasAttribute('aria-label')) card.setAttribute('aria-label', title);
      count += 1;
    }
  }
  return count;
}
